import { createSlice } from '@reduxjs/toolkit';
import { PaymentPlan, PaymentPlanWithUser } from '@dill/dill-shared';
import {
  getBuyerPaymentPlansExtraReducer,
  getSupplierPaymentPlansExtraReducer,
  createPaymentPlanExtraReducer,
  updatePaymentPlanExtraReducer,
  recordPaymentPlanPaymentExtraReducer,
  cancelPaymentPlanExtraReducer,
  deletePaymentPlanExtraReducer,
  getMainBuyerPaymentPlansExtraReducer,
  cancelMainBuyerPaymentPlanExtraReducer,
  confirmMainBuyerPaymentPlanExtraReducer,
  updateMainBuyerPaymentPlanPaymentMethodExtraReducer,
} from '../reducers/paymentPlanReducers';

export interface PaymentPlanInitialState {
  loadingList: string[];
  error: string | null;
  buyerPaymentPlans: PaymentPlanWithUser[];
  supplierPaymentPlans: PaymentPlanWithUser[];
  mainBuyerPaymentPlans: PaymentPlan[];
}

const initialState: PaymentPlanInitialState = {
  loadingList: [],
  error: null,
  buyerPaymentPlans: [],
  supplierPaymentPlans: [],
  mainBuyerPaymentPlans: [],
};

export const paymentPlanSlice = createSlice({
  name: 'paymentPlans',
  initialState,
  reducers: {
    resetPaymentPlanRootState: () => initialState,
    clearBuyerPaymentPlans: (state) => {
      state.buyerPaymentPlans = [];
    },
    clearPaymentPlanError: (state) => {
      state.error = null;
    },
  },
  extraReducers(builder) {
    getBuyerPaymentPlansExtraReducer(builder);
    getSupplierPaymentPlansExtraReducer(builder);
    createPaymentPlanExtraReducer(builder);
    updatePaymentPlanExtraReducer(builder);
    recordPaymentPlanPaymentExtraReducer(builder);
    cancelPaymentPlanExtraReducer(builder);
    deletePaymentPlanExtraReducer(builder);
    getMainBuyerPaymentPlansExtraReducer(builder);
    cancelMainBuyerPaymentPlanExtraReducer(builder);
    confirmMainBuyerPaymentPlanExtraReducer(builder);
    updateMainBuyerPaymentPlanPaymentMethodExtraReducer(builder);
  },
});

export const { resetPaymentPlanRootState, clearBuyerPaymentPlans, clearPaymentPlanError } =
  paymentPlanSlice.actions;
